module.exports = __webpack_public_path__ + "static/img/skype-3.5f963904.png";